import { useState, useEffect, useCallback } from "react";
import { FaBullseye, FaChartLine, FaCalendarCheck, FaMoneyBillWave } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import Loading from "../loading/loading";
import { viewDashboard, viewDashboardEvents } from "../http/api";
import { useAuth } from "../http/authcontex";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import '../common/style.css';
import './dashboard.css';

export default function DashboardComponent() {

    const localizer = momentLocalizer(moment);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authContext = useAuth();
    const [filteredEvents, setFilteredEvents] = useState([]);

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
        localStorage.getItem('sidebarCollapsed') === 'true'
    );

    const formatNumberWithCommas = (number) => {
        return number.toLocaleString();
      }
      

    useEffect(() => {
        localStorage.setItem('sidebarCollapsed', isSidebarCollapsed);
    }, [isSidebarCollapsed]);

    const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    const [totalTarget, setTotalTarget] = useState(0);
    const [totalAchivement, setTotalAchivement] = useState(0);
    const [totalTargetMonth, setTotalTargetMonth] = useState(0);
    const [totalAchivementMonth, setTotalAchivementMonth] = useState(0);


    const viewDashboardDetails = useCallback(() => {
        setLoading(true);
        viewDashboard()
            .then(response => {
                if (response.status === 200) {
                    setTotalTarget(response.data.total_trg / 100000);
                    setTotalAchivement(response.data.total_achiv / 100000);
                    setTotalTargetMonth(response.data.total_trg_month / 100000);
                    setTotalAchivementMonth(response.data.total_achiv_month / 100000);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewDashboardDetails();
    }, [viewDashboardDetails]);

    // Helper function to get start and end dates of a month
    const getMonthDateRange = (date) => {
        const start = moment(date).startOf('month').format('YYYY-MM-DD');
        const end = moment(date).endOf('month').format('YYYY-MM-DD');
        return { start, end };
    };

    const fetchEventsForMonth = useCallback((startDate, endDate) => {
        if (!startDate || !endDate) {
            console.error("Invalid start or end date for API call.");
            return;
        }

        setLoading(true);
        viewDashboardEvents(startDate, endDate, authContext.userEmail)
            .then(response => {
                if (response.status === 200) {
                    setFilteredEvents(response.data);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching events:', error);
                }
            });
    }, [authContext, navigate]);

    //Load events for the current month on initial render
    useEffect(() => {
        const { start, end } = getMonthDateRange(new Date());
        fetchEventsForMonth(start, end);
    }, [fetchEventsForMonth]);

    //Handle month navigation in the calendar
    const handleMonthChange = (date) => {
        const { start, end } = getMonthDateRange(date);
        fetchEventsForMonth(start, end);
    };


    const handleDateClick = (date) => {

        
        alert(`Details for ${date}: More info here!`); // Add more logic for showing detailed popup
    };

    return (
        <div className="DashboardComponent">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} />
                <div id="layoutSidenav">
                    <SideNave isSidebarCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar}/>
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Dashboard</h4>
                                <div className="row">
                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-primary text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaBullseye style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Total Target (Lakh)</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{formatNumberWithCommas(totalTarget)}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-success text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaChartLine style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Total Achv. (Lakh)</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{formatNumberWithCommas(totalAchivement)}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-info text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaCalendarCheck style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Target in Month (Lakh)</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{formatNumberWithCommas(totalTargetMonth)}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-md-6">
                                        <div className="card bg-warning text-white mb-4 shadow border-0">
                                            <div className="card-body d-flex align-items-center">
                                                <FaMoneyBillWave style={{ fontSize: '2rem' }} className="me-2" />
                                                <span>Achv. in Month (Lakh)</span>
                                            </div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <p className="text-white stretched-link">{formatNumberWithCommas(totalAchivementMonth)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card mb-4">
                                            <div className="card-header">
                                                <FaCalendarCheck className="me-1" /> Date Wise Activity
                                            </div>
                                            <div className="card-body">
                                                <div className="date-cases-container">
                                                    <Calendar
                                                        localizer={localizer}
                                                        events={filteredEvents}
                                                        startAccessor="start"
                                                        endAccessor="end"
                                                        style={{ height: 500 }}
                                                        popup={true}
                                                        popupOffset={{ x: 10, y: 30 }}  // You can tweak this for better positioning
                                                        onSelectEvent={(event) => alert(`Activity Details: ${event.title}`)}
                                                        onSelectSlot={(slotInfo) => handleDateClick(slotInfo.start)}
                                                        views={["month"]}
                                                        defaultView="month"
                                                        onNavigate={handleMonthChange}
                                                        />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
}